import { getToken, removeToken, getCookieKey, removeCookieKey } from "@/utils/auth";
import Cookies from "js-cookie";

const state = {
  token: getToken(),
  name: "",
  roles: [],
};

const mutations = {
  set_token: (state, token) => {
    state.token = token;
  },
  set_name: (state, name) => {
    state.name = name;
  },
  set_roles: (state, roles) => {
    state.roles = roles;
  },
};

const actions = {
  // get user info
  async getInfo({ commit, state }) {
    const token = getToken();
    const name = getCookieKey("name");
    const email = getCookieKey("email");
    if (token) {
      const user = {
        name,
        email,
        roles: ["admin","uara_operation"],
      };
      commit("set_roles", user.roles);
      commit("set_name", user.name);
      commit("set_token", token);
      return user;
    }
  },
  // remove token
  async resetToken({ commit }) {
    commit("set_token", "");
    commit("set_roles", []);
    commit("set_name", "");
    removeCookieKey("name");
    removeCookieKey("email");
    await removeToken();
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
